import _ from 'underscore';

import {FolderSummary} from 'constants/FolderConstants';
import {FinderResult, PROJECTS_FINDER_ID, REGISTRIES_FINDER_ID} from 'constants/NavConstants';
import FinderUtil from 'file-browser/FinderUtil';
import FolderDAO from 'file-browser/FolderDAO';
import * as FileUtil from 'folder-items/FileUtil';
import APIUtil from 'util/APIUtil';
import * as net from 'util/Net';

export function shouldDetectShortcuts(finderId: string): boolean {
  return finderId === PROJECTS_FINDER_ID;
}

export type ShouldShowShortcutItem = FileUtil.IsInRegistryItem;

export function shouldShowShortcut(file: ShouldShowShortcutItem, finderId?: string): boolean {
  if (!APIUtil.isBiologicalEntity(file.id)) {
    return false;
  }
  if (finderId === REGISTRIES_FINDER_ID) {
    // Never want to display shortcuts in registry listing
    return false;
  } else if (FileUtil.isInRegistry(file)) {
    // This enables the project shortcut icon to show up for all registered items in views outside
    // of registry listing
    return true;
  }
  return false;
}

export type GetParentFolderIdsWithShortcutsItem = ShouldShowShortcutItem &
  Pick<FinderResult, 'id' | 'folder' | 'parent'> & {projectFolderId: string};

export function getParentFolderIdsWithShortcuts(
  files: Array<GetParentFolderIdsWithShortcutsItem>,
  finderId: string
): Array<string> {
  return files
    .map((file) => {
      if (shouldShowShortcut(file, finderId)) {
        return file.projectFolderId;
      }
      return FinderUtil.parentFolderId(file);
    })
    .filter((file) => file != null);
}

export async function projectFolder(projectFolderId: string): Promise<FolderSummary | null> {
  try {
    return (await FolderDAO.fetch(projectFolderId, {summary: 1})) ?? null;
  } catch (e) {
    if (net.isServerRequestError(e) && e.status === 404) {
      return null;
    }
    throw e;
  }
}

export interface FindCommonProjectFolderIdItem {
  projectFolderId?: string;
}

export function findCommonProjectFolderId(files: Array<FindCommonProjectFolderIdItem>): string | null {
  const projectFolderIds = _.unique(
    files.map((file) => {
      if (file.projectFolderId) {
        return file.projectFolderId;
      }
      return null;
    })
  );
  if (projectFolderIds.length > 1) {
    return null;
  }
  return projectFolderIds[0];
}
